import axios from "axios";
import Constants from "../../../components.constants.js";


export default {

  async getSchedulerTaskDataFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.schedulerTaskUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getSchedulerTAskDataFromServer][Store][Error occured while getting userGroupslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getSchedulerClassServiveFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.schedulerClassServiceUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getSchedulerClassServiveFromServer][Store][Error occured while getting userGroupslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  // async getTriggersFromServer(context, payload = {}) {
  //   try {
  //     let resp = await axios.get(Constants.triggersUrl, payload);
  //     if (Constants.acceptedStatusCodes.includes(resp.status)) {
  //       resp.data.statusCode = resp.status
  //       return resp.data;
  //     }else {
  //       throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
  //     }
  //   } catch (error) {
  //     console.error(
  //       `[getTriggersFromServer][Store][Error occured while getting userGroupslist--->${error}]`
  //     );
  //     if (error.response) {
  //       if (error.response.status == 401){
  //         return context.dispatch("users/logOutFromServer", {},{root:true})
  //       }
  //       else {
  //         error.response.data.statusCode = error.response.status
  //         return error.response.data
  //       }
  //     }
  //     return {}
  //   }
  // },

  async postNewScheduler(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.schedulerTaskUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[postNewScheduler][Store][UserGroup add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[postNewScheduler][Store][Error occured while adding UserGroup--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async updateSchedulerData(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.schedulerTaskUrl+"/"+payload.schedulerId, payload.params);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateSchedulerData][Store][User add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateSchedulerData][Store][Error occured while adding user--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async deleteExistingScheduler(context, payload = {}) {
    //payload : {params:{tagId: "23412123"}, data:DAM Users JSON schema}

    try {
        let resp = await axios.delete(`${Constants.schedulerTaskUrl}/${payload.schedulerId}`, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[deleteExistingScheduler][Store][Tag Delete resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[deleteExistingScheduler][Store][Error occured while deleting User--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }

  },

  async postAdvancedValueToVerify(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.schedulerAdvancedVerifyUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[postAdvancedValueToVerify][Store][UserGroup add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[postAdvancedValueToVerify][Store][Error occured while adding UserGroup--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

};
